(function () {
  "use strict";

  const DRAWER_OPEN_DELAY = 600;
  const CART_UPDATE_EVENT = "cart:update";
  const RCC_SOURCE = "retail-connect-search";

  let cartSyncRequestToken = 0;

  function getCartUrl() {
    return `${window.Shopify?.routes?.root || "/"}cart.js`;
  }

  function getCartDrawer() {
    return document.querySelector("cart-drawer-component");
  }

  function getVisibleCartCount() {
    const bubbleCount = document.querySelector(".cart-bubble__text-count");
    const parsedCount = Number.parseInt(bubbleCount?.textContent || "0", 10);

    return Number.isNaN(parsedCount) ? 0 : parsedCount;
  }

  function getAddedItems(event) {
    const items = event?.detail?.response?.items;
    return Array.isArray(items) ? items : [];
  }

  function getAddedQuantity(items) {
    return items.reduce(
      (total, item) => total + (Number(item?.quantity) || 0),
      0,
    );
  }

  function dispatchCartUpdate(cart, items) {
    const firstAddedItem = items[0] || null;
    const fallbackItemCount = getVisibleCartCount() + getAddedQuantity(items);
    const itemCount = Number(cart?.item_count);

    document.dispatchEvent(
      new CustomEvent(CART_UPDATE_EVENT, {
        bubbles: true,
        detail: {
          resource: cart || null,
          sourceId: RCC_SOURCE,
          data: {
            source: RCC_SOURCE,
            itemCount: Number.isNaN(itemCount) ? fallbackItemCount : itemCount,
            productId: firstAddedItem?.product_id
              ? String(firstAddedItem.product_id)
              : undefined,
            variantId: firstAddedItem?.variant_id
              ? String(firstAddedItem.variant_id)
              : undefined,
          },
        },
      }),
    );
  }

  async function syncCartState(event) {
    const items = getAddedItems(event);
    const requestToken = ++cartSyncRequestToken;

    try {
      const response = await fetch(getCartUrl(), {
        credentials: "include",
        headers: {
          Accept: "application/json",
        },
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch cart: HTTP ${response.status}`);
      }

      const cart = await response.json();
      if (requestToken !== cartSyncRequestToken) return;

      dispatchCartUpdate(cart, items);
    } catch (error) {
      console.error("Retail Cloud Connect cart sync failed.", error);
      dispatchCartUpdate(null, items);
    }
  }

  window.addEventListener("retail-connect:add-to-cart:success", (event) => {
    const drawer = getCartDrawer();

    syncCartState(event)
      .catch((error) => {
        console.error("Retail Cloud Connect cart update failed.", error);
      })
      .finally(() => {
        setTimeout(() => {
          drawer?.open();
        }, DRAWER_OPEN_DELAY);
      });
  });
})();

window.Nimstrata = window.Nimstrata || {};
window.Nimstrata.filterOrder = window.Nimstrata.filterOrder || {};

window.Nimstrata.filterOrder["attributes.discount"] = function (lhs, rhs) {
  var sizeOrder = ["UP TO 20%", "20%", "30%", "40%", "50%", "60% AND MORE"];

  var lhsValue = String(lhs && lhs.value ? lhs.value : "")
    .trim()
    .toUpperCase();
  var rhsValue = String(rhs && rhs.value ? rhs.value : "")
    .trim()
    .toUpperCase();

  var lhsIndex = sizeOrder.indexOf(lhsValue);
  var rhsIndex = sizeOrder.indexOf(rhsValue);

  if (lhsIndex !== -1 && rhsIndex !== -1) {
    return lhsIndex - rhsIndex;
  }

  if (lhsIndex !== -1) return -1;
  if (rhsIndex !== -1) return 1;

  return lhsValue.localeCompare(rhsValue, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

window.Nimstrata.filterOrder["attributes.luggage_size"] = function (lhs, rhs) {
  var sizeOrder = [
    "CABIN SIZE (UP TO 55 CM)",
    "MEDIUM (56-69 CM)",
    "LARGE (70-79 CM)",
    "EXTRA LARGE (>80 CM)",
  ];

  var lhsValue = String(lhs && lhs.value ? lhs.value : "")
    .trim()
    .toUpperCase();
  var rhsValue = String(rhs && rhs.value ? rhs.value : "")
    .trim()
    .toUpperCase();

  var lhsIndex = sizeOrder.indexOf(lhsValue);
  var rhsIndex = sizeOrder.indexOf(rhsValue);

  if (lhsIndex !== -1 && rhsIndex !== -1) {
    return lhsIndex - rhsIndex;
  }

  if (lhsIndex !== -1) return -1;
  if (rhsIndex !== -1) return 1;

  return lhsValue.localeCompare(rhsValue, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

var capacityGroupStartByValue = {
  LESSTHAN10L: 0,
  "1019L": 10,
  "2029L": 20,
  "3039L": 30,
  "4049L": 40,
  "5059L": 50,
  "6069L": 60,
  "7079L": 70,
  "8089L": 80,
  "9099L": 90,
  "100109L": 100,
  "110119L": 110,
  "120129L": 120,
  "130139L": 130,
  "140LORMORE": 140,
};

function getFilterValue(filter) {
  if (filter == null) return "";
  if (typeof filter === "string" || typeof filter === "number") {
    return String(filter).trim();
  }

  return String(
    filter.value ||
      filter.label ||
      filter.name ||
      filter.title ||
      filter.id ||
      "",
  ).trim();
}

function getNormalizedRangeGroup(value) {
  return String(value || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, "")
    .replace(/-/g, "")
    .toUpperCase();
}

function getCompactCapacityGroupStart(value) {
  var compactMatch = String(value || "").match(/^(\d+)L$/i);
  if (!compactMatch) return null;

  var digits = compactMatch[1];
  if (digits.length >= 4 && digits.length % 2 === 0) {
    return Number(digits.slice(0, digits.length / 2));
  }

  return Number(digits);
}

function getCapacityGroupStart(value) {
  var normalizedValue = getNormalizedRangeGroup(value);
  if (
    Object.prototype.hasOwnProperty.call(
      capacityGroupStartByValue,
      normalizedValue,
    )
  ) {
    return capacityGroupStartByValue[normalizedValue];
  }

  var compactGroupStart = getCompactCapacityGroupStart(normalizedValue);
  if (compactGroupStart !== null) return compactGroupStart;

  var readableValue = String(value || "").toLowerCase();
  if (/(^|[\s<])less\s*than|under\s*\d|^<\s*\d/.test(readableValue)) {
    return 0;
  }

  var firstNumber = readableValue.match(/\d+(?:[.,]\d+)?/);
  return firstNumber ? Number(firstNumber[0].replace(",", ".")) : Infinity;
}

function compareCapacityGroups(lhs, rhs) {
  var lhsValue = getFilterValue(lhs);
  var rhsValue = getFilterValue(rhs);
  var lhsStart = getCapacityGroupStart(lhsValue);
  var rhsStart = getCapacityGroupStart(rhsValue);

  if (lhsStart !== rhsStart) {
    return lhsStart - rhsStart;
  }

  return lhsValue.localeCompare(rhsValue, undefined, {
    numeric: true,
    sensitivity: "base",
  });
}

var weightGroupStartByValue = {
  LESSTHAN500G: 0,
  "500999G": 500,
  "1199KG": 1000,
  "2299KG": 2000,
  "3399KG": 3000,
  "4499KG": 4000,
  "5KGORMORE": 5000,
};

function getCompactWeightGroupStart(value) {
  var compactMatch = String(value || "").match(/^(\d+)(KG|G)$/i);
  if (!compactMatch) return null;

  var digits = compactMatch[1];
  var unit = compactMatch[2].toUpperCase();

  if (unit === "G") {
    if (digits.length >= 4 && digits.length % 2 === 0) {
      return Number(digits.slice(0, digits.length / 2));
    }

    return Number(digits);
  }

  for (var splitIndex = 1; splitIndex < digits.length; splitIndex += 1) {
    var start = digits.slice(0, splitIndex);
    var end = digits.slice(splitIndex);

    if (end === start + "99") {
      return Number(start) * 1000;
    }
  }

  return Number(digits) * 1000;
}

function getWeightGroupStart(value) {
  var normalizedValue = getNormalizedRangeGroup(value);
  if (
    Object.prototype.hasOwnProperty.call(
      weightGroupStartByValue,
      normalizedValue,
    )
  ) {
    return weightGroupStartByValue[normalizedValue];
  }

  var compactGroupStart = getCompactWeightGroupStart(normalizedValue);
  if (compactGroupStart !== null) return compactGroupStart;

  var readableValue = String(value || "").toLowerCase();
  if (/(^|[\s<])less\s*than|under\s*\d|^<\s*\d/.test(readableValue)) {
    return 0;
  }

  var firstNumber = readableValue.match(/\d+(?:[.,]\d+)?/);
  if (!firstNumber) return Infinity;

  var start = Number(firstNumber[0].replace(",", "."));
  if (!Number.isFinite(start)) return Infinity;

  return readableValue.indexOf("kg") !== -1 ? start * 1000 : start;
}

function compareWeightGroups(lhs, rhs) {
  var lhsValue = getFilterValue(lhs);
  var rhsValue = getFilterValue(rhs);
  var lhsStart = getWeightGroupStart(lhsValue);
  var rhsStart = getWeightGroupStart(rhsValue);

  if (lhsStart !== rhsStart) {
    return lhsStart - rhsStart;
  }

  return lhsValue.localeCompare(rhsValue, undefined, {
    numeric: true,
    sensitivity: "base",
  });
}

window.Nimstrata.filterOrder["attributes.capacity_group"] =
  compareCapacityGroups;
window.Nimstrata.filterOrder["attributes.capacity"] = compareCapacityGroups;
window.Nimstrata.filterOrder["attributes.weight_group"] = compareWeightGroups;
window.Nimstrata.filterOrder["attributes.weight"] = compareWeightGroups;
